import styled from "styled-components";

const Style = styled.div`
  display: flex;

  .item {
    min-height: 50px;
    border-right: 1px solid var(--base-gray-30);

    &:last-of-type {
      border-right: 0px;
    }

    label {
      color: var(--base-gray-80);
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
    }

    .item-value {
      display: flex;
      gap: 8px;
      
      .ant-tag {
        margin-right: 0px;
      }

      img {
        width: 24px !important;
        height: 22px !important;
        border-radius: 1000px;
      }
    }
  }

`;

export default Style;
